import { render, staticRenderFns } from "./ExamRoutine.vue?vue&type=template&id=98bf8d78&"
import script from "./ExamRoutine.vue?vue&type=script&lang=js&"
export * from "./ExamRoutine.vue?vue&type=script&lang=js&"
import style0 from "./ExamRoutine.vue?vue&type=style&index=0&id=98bf8d78&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports